import {
  Avatar as ChakraAvatar,
  Flex,
  StackProps,
  Text,
} from "@chakra-ui/react";

import {
  Avatar,
  AvatarProps,
  AvatarSizeProp,
} from "@/common/components/Avatar";
import { IcoServiceAccountAvatar } from "@/common/components/Icons";
import { ReflagUser } from "@reflag/shared/types/ReflagUser";

type Props = StackProps & {
  actor: ReflagUser | null | string;
  size?: AvatarSizeProp;
  _avatar?: AvatarProps;
};

export const ServiceAccountText = "Service Account";

export function ChangeActorDisplay({ actor, size, _avatar, ...rest }: Props) {
  if (!actor || typeof actor === "string") {
    return (
      <Flex
        alignItems="center"
        gap={2}
        whiteSpace="nowrap"
        isTruncated
        {...rest}
      >
        <ChakraAvatar
          icon={<IcoServiceAccountAvatar />}
          size={size ?? "2xs"}
          {..._avatar}
        />
        <Text color="dimmed" fontStyle="italic" isTruncated>
          {actor ?? ServiceAccountText}
        </Text>
      </Flex>
    );
  } else {
    return (
      <Flex
        alignItems="center"
        gap={2}
        whiteSpace="nowrap"
        isTruncated
        {...rest}
      >
        <Avatar
          name={actor.name}
          src={actor.avatarUrl ?? undefined}
          {..._avatar}
        />
        <Text isTruncated>{actor.name}</Text>
      </Flex>
    );
  }
}
